<template>
  <div class="opinion_list" v-loading="loading">
    <div class="s_wrapper">
      <!-- <el-date-picker class="" v-model="datetime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="onSearch" clearable></el-date-picker> -->
      <el-date-picker v-model="createdTime" type="date" placeholder="反馈日期" value-format="yyyy-MM-dd" @change="onSearch"></el-date-picker>
      <el-select class="s_input" v-model="replyStatus" placeholder="选择处理状态" @change="onSearch" clearable>
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <!-- <el-button class="btn" type="primary" plain>导出</el-button> -->
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="userName" label="用户名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="content" label="反馈内容"></el-table-column>
        <el-table-column label="图片">
          <template slot-scope="scope">
            <span class="show_img" @click="previewPic(scope.row)">查看图片</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="createdTime" label="反馈日期"></el-table-column>
        <el-table-column show-overflow-tooltip prop="" label="处理状态">
          <template slot-scope="scope">
            <span :style="scope.row.replyStatus == 0 ? 'color:red;' : ''">{{ scope.row.replyStatus == 0 ? "未回复" : "已回复" }}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" width="120">
          <template slot-scope="scope">
            <el-button v-if="scope.row.replyStatus == 1" type="" plain @click="handleShow(scope.row)">查看详情</el-button>
            <el-button v-if="scope.row.replyStatus == 0" type="primary" plain @click="handleShow(scope.row)">回复意见</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-dialog :title="isAdd ? '回复意见' : '查看详情'" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="ruleForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="图片">
              <span v-if="ruleForm.picUrls.length == 0" style="color: #c0c4cc">用户未上传图片</span>
              <el-image v-else class="picurl" v-for="(item, index) in ruleForm.picUrls" :key="index" :src="item" :preview-src-list="ruleForm.picUrls" fit="cover"></el-image>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户名称">
              <el-input v-model="ruleForm.userName" disabled></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="反馈日期">
              <el-input v-model="ruleForm.createdTime" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="反馈内容">
              <el-input v-model="ruleForm.content" type="textarea" :rows="4" resize="none" disabled></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="回复内容" :required="isAdd">
              <el-input v-model="ruleForm.replyContent" type="textarea" :rows="4" resize="none" :disabled="!isAdd" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button v-if="isAdd" type="primary" @click="onSubmit('ruleForm')" :loading="submitLoding">确 定</el-button>
      </span>
    </el-dialog>

    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false
        }
      "
      :url-list="srcList"
    ></el-image-viewer>
  </div>
</template>

<script>
function createInitRuleForm() {
  return {
    replyContent: "",
    userName: "",
    createdTime: "",
    content: "",
    picUrls: [],
  }
}
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      loading: false,
      tableData: [],
      options: [
        { value: "0", label: "未回复" },
        { value: "1", label: "已回复" },
      ],
      replyStatus: "",
      createdTime: "",
      // datetime: [],
      isAdd: false,
      showViewer: false,
      dialogVisible: false,
      submitLoding: false,
      srcList: [],
      ruleForm: createInitRuleForm(),

      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 意见列表
    getList() {
      // let startTime, endTime
      // if (this.datetime && this.datetime.length > 0) {
      //   startTime = this.datetime[0]
      //   endTime = this.datetime[1]
      // } else {
      //   startTime = ""
      //   endTime = ""
      // }
      this.loading = true
      this.$axios
        .get(this.$api.userFeedbackselectUserFeedback, {
          params: {
            createdTime: this.createdTime || "",
            replyStatus: this.replyStatus, // 状态 (0未回复，1已回复)
            page: this.currentPage, // 页码数
            pageSize: this.pageSize, // 每页数量
          },
        })
        .then(res => {
          this.tableData = res.result.list
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getList()
    },
    // 导出
    onExprot() {
      this.tableData = []
      this.currentPage = 1
      this.getList()
    },
    handleShow(e) {
      if (e.replyStatus == 0) {
        this.isAdd = true
      } else {
        this.isAdd = false
      }
      this.ruleForm = Object.assign({}, e)
      this.dialogVisible = true
    },
    // 提交回复
    onSubmit() {
      if (this.ruleForm.replyContent && this.ruleForm.replyContent != "") {
        this.submitLoding = true
        this.$axios
          .post(this.$api.userFeedbackreply, {
            id: this.ruleForm.id,
            replyContent: this.ruleForm.replyContent,
          })
          .then(res => {
            this.$message.success("回复成功")
            this.submitLoding = false
            this.dialogVisible = false
            this.getList()
          })
          .catch(err => {
            this.$message.error(err.desc)
            this.submitLoding = false
          })
      } else {
        this.$message.error("提交失败，回复内容不能为空")
      }
    },
    onCancel() {
      this.resetForm()
      this.dialogVisible = false
    },
    // 图片预览
    previewPic(e) {
      this.srcList = e.picUrls
      this.showViewer = true
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getSysUserList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getSysUserList()
    },
    // 重置校验
    resetForm() {
      this.ruleForm = createInitRuleForm()
      this.$refs.ruleForm.resetFields()
    },
  },
}
</script>

<style scoped lang="scss">
.opinion_list {
  .show_img {
    color: $themes;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  .ruleForm {
    .picurl {
      width: 100px;
      height: 100px;
      border-radius: 6px;

      &:not(:first-child) {
        margin-left: 16px;
      }
    }

    ::v-deep .el-input,
    ::v-deep .el-input__inner {
      width: 100%;
    }
  }
}
</style>
